import React from 'react';

export function StepEditLabel() {
  return <>Editace údajů</>;
}
